export const actions = {
    START_FETCHING_WORKSPACE: "START_FETCHING_WORKSPACE",
    FETCH_WORKSPACE_SUCCESSFUL: "FETCH_WORKSPACE_SUCCESSFUL",
    FETCH_WORKSPACE_FAILED: "FETCH_WORKSPACE_FAILED",

    STORE_WORKSPACE_DATA: "STORE_WORKSPACE_DATA",
};

export const initialState = {
    listingFetching: false,
    listingResponse: {},
    singleFetching: [],
};

export default (state = initialState, { type, response, iri }) => {
    switch (type) {
        case actions.START_FETCHING_WORKSPACE: {
            return {
                ...state,
                singleFetching: true,
            };
        }
        case actions.FETCH_WORKSPACE_SUCCESSFUL: {
            return {
                ...state,
                singleFetching: false,
            };
        }
        case actions.FETCH_WORKSPACE_FAILED: {
            return {
                ...state,
                singleFetching: false,
            };
        }
        case actions.STORE_WORKSPACE_DATA: {
            return Object.assign({}, state, {
                [iri]: response,
            });
        }
        default:
            return state;
    }
};
